import React from 'react';
import KeyboardShortcutItem from './KeyboardShortcutItem';
import { ShortcutsListProps } from './ShortcutHelper.props';

const ShortcutsList: React.FC<ShortcutsListProps> = ({ browserOS, shortcuts }) => (
  <>
    {shortcuts.map(({ action, combination }) => (
      <KeyboardShortcutItem action={action} combination={combination[browserOS ?? 'windows']} key={action} />
    ))}
  </>
);

export default ShortcutsList;
